import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import PopUp from '../../../popUp'
import { pushErrorOpenPopup, pushErrorClosePopup } from '../../../../helpers/gtm'
import './styles.scss'

class GlobalErrorPopUpSMSWENTWRNG extends React.PureComponent {
  static propTypes = {
    message: PropTypes.objectOf(Object),
  }

  static defaultProps = {
    message: {
      title: 'Something went wrong',
      description: 'Something went wrong description',
      link: 'Reload',
    },
  }

  componentDidMount() {
    pushErrorOpenPopup()
  }

  componentWillUnmount() {
    pushErrorClosePopup()
  }


  render() {
    const {
      message: {
        title,
        description,
        link,
      },
    } = this.props

    const onClose = (e) => {
      e.preventDefault()
      window.location.reload()
    }

    return (
      <PopUp onCloseFunc={onClose}>
        <div className="global-popup">
          <div className="global-error-popup">
            <div className="popup-holder">
              <strong className="ttl">
                {title}
              </strong>
              <p dangerouslySetInnerHTML={{ __html: description }} />

              <div className="btn-holder">
                <a
                  onClick={onClose}
                  href="#"
                >
                  {link}
                </a>
              </div>
            </div>
          </div>
        </div>
      </PopUp>
    )
  }
}

export default connect(({
  main: {
    setting: {
      booking: {
        secondStep: {
          errorPopup: {
            message,
          },
        },
      },
    },
  },
}) => ({
  message,
}), dispatch => ({
}))(GlobalErrorPopUpSMSWENTWRNG)
